// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    decimalPriceRange: 0,
    removePriceDecimal: true, // Remove ‘.00’
    decimalDelimiter: ".",
  },
};

(function () {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function () {};

  SearchInput.prototype.afterBindEvents = function () {
    // Fix cannot close search suggestion when clicking overlay
    document.addEventListener(
      "click",
      function (e) {
        if (
          this.searchAutoComplete &&
          this.searchAutoComplete.isOpen &&
          e &&
          e.target
        ) {
          var $clickedElement = jQ(e.target);
          var isClickSuggestion =
            $clickedElement.closest("." + Class.searchSuggestionWrapper)
              .length > 0;
          if (isClickSuggestion) {
            this.searchAutoComplete.$element.hide();
            this.searchAutoComplete.searchInput.onCloseAutocomplete();
            this.searchAutoComplete.isOpen = false;
          }
        }
      }.bind(this),
      true
    );
  };
  /* Starts Boost 204539 */
  
  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice =
    function () {
      // If the multi-currency feature is enabled, update the product price
      this.prepareSuggestionProductPriceData();
      // Check on sale
      var onSale = this.data.compare_at_price_min > this.data.price_min;
      // Format price
      // var price = Utils.formatMoney(Math.trunc(this.data.price_min * 100) / 100) ;
      var price = Utils.formatMoney(this.data.price_min).replace(/(\.|,)00$/g, '');
      var compareAtPrice = "";
      if (this.data && this.data.compare_at_price_min) {
        compareAtPrice = Utils.formatMoney(
          this.data.compare_at_price_min * 100
        );
        if (Settings.getSettingValue('search.removePriceDecimal')) {
          price = this.removeDecimal(price);
          compareAtPrice = this.removeDecimal(compareAtPrice);
        }
      }
      // Build Price
      var result = "";
      if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
        if (
          onSale &&
          Settings.getSettingValue('search.showSuggestionProductSalePrice')
        ) {
          result = this.getTemplate(
            InstantSearchResultItemProduct.tempType.PRICE_SALE
          );
        } else {
          result = this.getTemplate(
            InstantSearchResultItemProduct.tempType.PRICE
          );
        }
      }
      return result
        .replace(/{{regularPrice}}/g, price)
        .replace(/{{compareAtPrice}}/g, compareAtPrice);
    };
  /* Ends Boost 204539 */
  InstantSearchApi.beforeCall = function (searchTerm) {
    /* Change the params before calling api */
    Globals.instantSearchQueryParams.sort = "created-descending";
  };
})();
